import { getIdFromUrl } from "../../helpers";

export const getSiteIdFromUrl = (url: string) =>
  getIdFromUrl(url)("site", 3, 4);
